<script>
  import formFieldMixin from './form-field-mixin.js'
  import dataUrlMixin from '../generic/dataurl-mixin.js'

  export default {
    mixins: [
      formFieldMixin,
      dataUrlMixin
    ],
    computed: {
      dataUrl () {
        return this.value
      },
      dropPlaceholder () {
        return this.$t(`${this.translations}.${this.propName}.drop-placeholder`)
      }
    },
    methods: {
      updateFromFile (file) {
        if (file) {
          this.updateFromBlob(file).then(() => {
            this.$emit('fileLoaded', file.name)
          })
        }
      },
      updateFromPlaintext (text) {
        this.updateFromBlob(new Blob([text], {type:this.mimeType || 'text/plain'}))
      },
      updateFromBlob (blob) {
        return new Promise((resolve) => {
          const reader  = new FileReader();
          reader.addEventListener('load', () => {
            this.updateField(reader.result)
            resolve()
          }, false);

          reader.readAsDataURL(blob)
        })
      },
      clear () {
        this.updateField(null)
      }
    }
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <b-form-file
      :id="inputName"
      :name="inputName"
      :placeholder="placeholder"
      :drop-placeholder="dropPlaceholder"
      @input="updateFromFile($event)"
      :state="!isInvalid"
      :disabled="!isReadOnly"
      trim
      :autocomplete="autocomplete"
    ></b-form-file>
    <div>{{ (binary || '').length }} Bytes</div>
    <b-img v-if="isImage" fluid :src="dataUrl" />
    <b-textarea
      v-if="isText"
      :id="inputName + '-code'"
      :value="text"
      :placeholder="placeholder"
      @input="updateFromPlaintext($event)"
      :state="!isInvalid"
      :readonly="isReadOnly"
      :rows="10"
      trim
    ></b-textarea>
  </b-form-group>
</template>
